module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "add",
    on: {
      "click": _vm.toAddressAdd
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-address-add@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', [_vm._v("添加地址")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "address_list"
  }, _vm._l((_vm.addressList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "address_info",
      on: {
        "click": function($event) {
          return _vm.addressEdit(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "header2"
    }, [_c('h1', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('h1', {
      staticStyle: {
        "margin-left": "7px"
      }
    }, [_vm._v(_vm._s(item.phone))]), _vm._v(" "), (item.is_default == 1) ? _c('div', {
      staticClass: "first"
    }, [_vm._v("默认")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "body"
    }, [_vm._v(_vm._s(item.address))])]), _vm._v(" "), _c('div', {
      staticClass: "line"
    })])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b00eba6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/address2/AddressList.vue
// module id = 2418
// module chunks = 0